export default __webpack_public_path__ + "7a03d297e9204dcb5db588b42902e0de.svg";